//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 

import Autocomplete from 'vue2-autocomplete-js';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';

const ADD_URL = "http://localhost:5012/" + "api/v1/profile/";
const FILE_LOAD = "http://localhost:5012/" + "uploads/";

export default {
    components: {
          Autocomplete,
    },      
    data () {
        return {
            token : localStorage.token,          
            tab: 'profile1',

            showEditProfileModal: false,
            showEditPasswordModal: false,

            shape: '',
            permohonan_ktp:'', 
            dense:true, 
            current : 3, 
            model: '', 
            text: '', 
            
            search:'',
            list_data: [],

            warna_n : 'red-8' ,
            warna_y : 'blue-8' ,  
            nik : "",
            user_name : 'Fajar08' ,  
            nama_lengkap : 'Fajar Syahputra' ,  
            email : 'mail@gmail.com' ,  
               
            password1 : '' ,  
            password2 : '' ,  
            
            telepon: "",
            salah : "",
            hijau : "",
            isPwd1: true,
            isPwd2: true,

            ispasword:null,


            form: {

              profil_id:'',

              id: '',
              email: '',
              hp: '',
              kelas: '',
              level: '',
              nama: '',
              password1 : '' ,  
              password2 : '' ,  

              username: '',
              provinsi: '',
              kabupaten: '',
              kecamatan: '',
              desa_kelurahan: '', 
              // m_kabupaten : '',
              // m_kecamatan : '',
              // m_desa_kelurahan : '',

              files: [],  
              
            },

            cari_value:'',
            cari_byLevel:'',            

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },

            file:'',
            progressss:0,
            uploading : false,
            progress: 0,



        }
    },
    methods: {

      getView: function () {
        console.log('get view = ' + this.form.profil_id);
        this.form.profil_id

        fetch(this.$store.state.url.URL_REGISTRASI + "view_contoh3", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body:JSON.stringify({
              id               : this.form.profil_id,
              provinsi         : this.form.provinsi,
              kabupaten        : this.form.kabupaten,
              kecamatan        : this.form.kecamatan,
              desa_kelurahan   : this.form.desa_kelurahan
            })
          })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data.data);
                this.list_data  = res_data.data;
                var a           = res_data.data[0]
                this.gantiDataForm(a)
        });        
      },

      gantiDataForm:function(a){
              console.log('aaassss' + a);
              this.form.id             = a.id
              this.form.email          = a.email
              this.form.hp             = a.hp
              this.form.kelas          = a.kelas
              this.form.level          = a.level
              this.form.nama           = a.nama
              this.form.password1      = ''
              this.form.username       = a.username

              this.form.provinsi       = a.provinsi
              this.form.kabupaten      = a.kabupaten
              this.form.kecamatan      = a.kecamatan
              this.form.desa_kelurahan = a.desa_kelurahan

              // this.wilayah = {
              //   uraian_provinsi         : a.m_provinsi.uraian,
              //   kd_provinsi             : a.m_provinsi.kd_provinsi,
              //   uraian_kabupaten        : a.m_kabupaten.uraian,
              //   kd_kabupaten            : a.m_kabupaten.kd_kabupaten,
              //   uraian_kecamatan        : a.m_kecamatan.uraian,
              //   kd_kecamatan            : a.m_kecamatan.kd_kecamatan,
              //   uraian_desa_kelurahan   : a.m_desa_kelurahan.uraian,
              //   kd_desa_kelurahan       : a.m_desa_kelurahan.kd_desa_kelurahan,
              // };                


      },
      
      
    tombol_file () { 
      // ketika mengklik tombol menggunakan ref="" untuk referensi inputan
      this.$refs.fileInput.click()
    },       
     fotoProfile (event) {
      // ketika Input berjalan tombol
      this.form.files = event.target.files[0];
      // console.log('fotoProfile jlan');
      console.log(this.form.files);
      

      // var formData = new FormData();
      // formData.append("file", this.file); 
    },
    
    progressLabel1 () {
      return (this.progress1 * 100).toFixed(2) + '%'
    },

      showNotif () {
        this.$q.notify({
                message: 'Anda yakin dengan data yang akan anda masukan?.',
                position:'center' ,
                color: 'secondary',
                timeout: 0, 
                icon:'announcement',
                actions: [
                  { label: 'Yakin', color: 'yellow', handler: () => { this.add_data() } }, 
                  { label: 'Tidak', color: 'white', handler: () => { this.$store.state.modal = false } }
                ]
              })
              
      },
      showNotifEdit () {
        this.$q.notify({
                message: 'Anda yakin dengan data yang anda edit?.',
                position:'center' ,
                color: 'warning',
                timeout: 0, 
                icon:'announcement',
                actions: [
                  { label: 'Yakin', color: 'yellow', handler: () => { this.editProfileData() } },
                  { label: 'Tidak', color: 'white', handler: () => { this.$store.state.modal = false } }
                ]
              })
              
      },

      showNotifEditProfile () {
        this.$q.notify({
                message: 'Simpan perubahan profile?',
                position:'center' ,
                color: 'warning',
                timeout: 0, 
                icon:'announcement',
                actions: [
                  { label: 'Yakin', color: 'yellow', handler: () => { this.editProfileDataOnly() } }, 
                  { label: 'Tidak', color: 'white', handler: () => { } }
                ]
              })
      },

      showNotifEditPassword () {
        this.$q.notify({
                message: 'Ubah password?',
                position:'center' ,
                color: 'warning',
                timeout: 0, 
                icon:'announcement',
                actions: [
                  { label: 'Yakin', color: 'yellow', handler: () => { this.editPasswordOnly() } }, 
                  { label: 'Tidak', color: 'white', handler: () => { } }
                ]
              })
      },

      password_fungsi(){
        if (this.form.password1 !== this.form.password2) {
          this.salah = 'red-5'
          return this.ispasword= "salah"
          
        } else {
          this.salah = 'green-5'
          this.hijau = 'green-5'
          return this.ispasword= "Benar"
          
        }
      },

      getPasswordColor(){
        if (!this.form.password1 && !this.form.password2) return '';
        if (this.form.password1 && this.form.password2 && this.form.password1 === this.form.password2) {
          return 'green-5'
        } else if (this.form.password1 || this.form.password2) {
          return 'red-5'
        }
        return '';
      },

      resetForm(){
        // Reset form ke data asli dari localStorage
        var get_profile = JSON.parse(localStorage.profile)
        this.form.username       = get_profile.username
        this.form.nama           = get_profile.nama
        this.form.email          = get_profile.email
        this.form.hp             = get_profile.hp
        this.form.password1      = ''
        this.form.password2      = ''
        this.$q.notify({
          message: 'Form direset ke data asli',
          position: 'top',
          color: 'info',
          timeout: 2000
        })
      },

      resetPasswordForm(){
        this.form.password1 = ''
        this.form.password2 = ''
        this.isPwd1 = true
        this.isPwd2 = true
      },

      editProfileDataOnly(){
        // Edit hanya profile data tanpa password
        this.uploading = true

        const updateData = {
          id:          this.form.id,
          username:    this.form.username,
          nama:        this.form.nama,
          email:       this.form.email,
          hp:          this.form.hp
        }

        console.log('Updating profile:', updateData)

        fetch(this.$store.state.url.URL_REGISTRASI + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(updateData)
        })
          .then(res => res.json())
          .then(res_data => {
            this.uploading = false
            
            if (res_data.success) {
              // Update localStorage
              var updated_profile = JSON.parse(localStorage.profile)
              updated_profile.username = this.form.username
              updated_profile.nama = this.form.nama
              updated_profile.email = this.form.email
              updated_profile.hp = this.form.hp
              localStorage.profile = JSON.stringify(updated_profile)

              this.$q.notify({
                message: res_data.message || 'Profile berhasil diperbarui!',
                position: 'top',
                color: 'positive',
                icon: 'check_circle',
                timeout: 2000
              })

              this.showEditProfileModal = false
              this.getView()
            } else {
              this.$q.notify({
                message: res_data.message || 'Gagal memperbarui profile',
                position: 'top',
                color: 'negative',
                icon: 'error',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            this.uploading = false
            console.error('Error:', error)
            this.$q.notify({
              message: 'Terjadi kesalahan: ' + error.message,
              position: 'top',
              color: 'negative',
              icon: 'error',
              timeout: 2000
            })
          })
      },

      editPasswordOnly(){
        // Edit hanya password
        if (this.form.password1 !== this.form.password2) {
          this.$q.notify({
            message: 'Password tidak cocok!',
            position: 'top',
            color: 'negative',
            icon: 'warning',
            timeout: 2000
          })
          return
        }

        if (this.form.password1.length < 6) {
          this.$q.notify({
            message: 'Password minimal 6 karakter!',
            position: 'top',
            color: 'negative',
            icon: 'warning',
            timeout: 2000
          })
          return
        }

        this.uploading = true

        const updateData = {
          id        : this.form.id,
          username  : this.form.username,
          password  : this.form.password1
        }

        console.log('Updating password')

        fetch(this.$store.state.url.URL_REGISTRASI + "editPassword", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(updateData)
        })
          .then(res => res.json())
          .then(res_data => {
            this.uploading = false
            
            if (res_data.success) {
              this.$q.notify({
                message: res_data.message || 'Password berhasil diubah!',
                position: 'top',
                color: 'positive',
                icon: 'check_circle',
                timeout: 2000
              })

              this.resetPasswordForm()
              this.showEditPasswordModal = false
            } else {
              this.$q.notify({
                message: res_data.message || 'Gagal mengubah password',
                position: 'top',
                color: 'negative',
                icon: 'error',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            this.uploading = false
            console.error('Error:', error)
            this.$q.notify({
              message: 'Terjadi kesalahan: ' + error.message,
              position: 'top',
              color: 'negative',
              icon: 'error',
              timeout: 2000
            })
          })
      },

      editProfileData(){
        // Validasi password jika ada perubahan
        if ((this.form.password1 || this.form.password2) && this.form.password1 !== this.form.password2) {
          this.$q.notify({
            message: 'Password tidak cocok!',
            position: 'top',
            color: 'negative',
            icon: 'warning',
            timeout: 2000
          })
          return
        }

        this.uploading = true

        // Prepare data to send
        const updateData = {
          id: this.form.id,
          username: this.form.username,
          nama: this.form.nama,
          email: this.form.email,
          hp: this.form.hp
        }

        // Only include password if provided
        if (this.form.password1) {
          updateData.password = this.form.password1
        }

        console.log('Updating profile:', updateData)

        fetch(this.$store.state.url.URL_REGISTRASI + "update_profile", {
          method: "PUT",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(updateData)
        })
          .then(res => res.json())
          .then(res_data => {
            this.uploading = false
            
            if (res_data.status === 'success' || res_data.success) {
              // Update localStorage
              var updated_profile = JSON.parse(localStorage.profile)
              updated_profile.username = this.form.username
              updated_profile.nama = this.form.nama
              updated_profile.email = this.form.email
              updated_profile.hp = this.form.hp
              localStorage.profile = JSON.stringify(updated_profile)

              this.$q.notify({
                message: 'Profile berhasil diperbarui!',
                position: 'top',
                color: 'positive',
                icon: 'check_circle',
                timeout: 2000
              })

              // Reset password fields
              this.form.password1 = ''
              this.form.password2 = ''

              // Go back to profile1 tab
              this.tab = 'profile1'
              
              // Reload profile data
              this.getView()
            } else {
              this.$q.notify({
                message: res_data.message || 'Gagal memperbarui profile',
                position: 'top',
                color: 'negative',
                icon: 'error',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            this.uploading = false
            console.error('Error:', error)
            this.$q.notify({
              message: 'Terjadi kesalahan: ' + error.message,
              position: 'top',
              color: 'negative',
              icon: 'error',
              timeout: 2000
            })
          })
      },

      add_data(){
        var row = this.list_data;
        row.push(this.$store.state.form);  
        this.$store.state.form = {
          modul:this.modul,
        }
        console.log(row[0]);
        
      },
    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },   
       
      get_auto(data){
        console.log(data.kd_provinsi); 
        this.form.provinsi = data.m_provinsi  
      },        
      get_auto_kab(data){ 
        this.form.kabupaten = data.m_kabupaten 
        console.log(data.kd_kabupaten); 
      },        
      get_auto_kec(data){ 
        this.form.kecamatan = data.m_kecamatan 
        console.log(data.kd_kecamatan); 
      },        
      get_auto_des_kel(data){ 
        this.form.desa_kelurahan = data.m_desa_kelurahan 
        console.log(data.kd_desa_kelurahan); 
      },        
    // ====================================== filter autocomplete                  

     
 
 
      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
            return `${filesNumber} files of ${maxFiles} | ${totalSize}`
      },       
        async awaitFetch(){ 
          // this.listTahun = await this.FETCHING.getlist(this.$store.state.url.URL_TAHUN);
          // this.listBulan = await this.FETCHING.getlist(this.$store.state.url.URL_BULAN); 

        },      
      
    },

    mounted() {
      // this.awaitFetch()
        var get_profile = JSON.parse(localStorage.profile) 
        this.form.profil_id = get_profile.id
        this.form.id = get_profile.id
        this.form.username = get_profile.username
        this.form.nama = get_profile.nama
        this.form.email = get_profile.email
        this.form.hp = get_profile.hp
        // console.log(get_profile.level);
        

        this.form.provinsi        = get_profile.provinsi
        this.form.kabupaten       = get_profile.kabupaten
        this.form.kecamatan       = get_profile.kecamatan
        this.form.desa_kelurahan  = get_profile.desa_kelurahan

        this.getView() 

    },
    
}
